import { createAction, props } from '@ngrx/store';
import {
  AircraftEventSkeleton,
  PagedAircraftEventAudit,
  PagedAircraftEventBusinessPersonAudit,
  PagedScheduledEventAudit
} from '../../+models/aircraft-event-audit.model';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';

export const ResetAircraftEvent = createAction('[SharedAudit AircraftEvent] Reset');

export const LoadAircraftEventSkeletons = createAction(
  '[SharedAudit AircraftEvent] Load AircraftEvent Skeletons'
);

export const AircraftEventSkeletonsLoaded = createAction(
  '[SharedAudit AircraftEvent] AircraftEvent Skeletons Loaded',
  props<{ payload: AircraftEventSkeleton[] }>()
);

export const AircraftEventSkeletonsLoadError = createAction(
  '[SharedAudit AircraftEvent] AircraftEvent Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadAircraftEventAudit = createAction(
  '[SharedAudit AircraftEvent] Load AircraftEvent Audit',
  props<{ aircraftEventId: number }>()
);

export const LoadNextPageAircraftEventAudit = createAction(
  '[SharedAudit AircraftEvent] Load Next Page AircraftEvent Audit',
  props<{ aircraftEventId: number }>()
);

export const AircraftEventAuditLoaded = createAction(
  '[SharedAudit AircraftEvent] AircraftEvent Audit Loaded',
  props<{ aircraftEventId: number; audits: PagedAircraftEventAudit }>()
);

export const AircraftEventAuditLoadError = createAction(
  '[SharedAudit AircraftEvent] AircraftEvent Audit Load Error',
  props<{ err: any }>()
);

export const LoadAircraftEventBusinessPersonAudit = createAction(
  '[SharedAudit AircraftEvent] Load AircraftEventBusinessPerson Audit',
  props<{ aircraftEventBusinessPersonId: number }>()
);

export const LoadNextPageAircraftEventBusinessPersonAudit = createAction(
  '[SharedAudit AircraftEvent] Load Next Page AircraftEventBusinessPerson Audit',
  props<{ aircraftEventBusinessPersonId: number }>()
);

export const AircraftEventBusinessPersonAuditLoaded = createAction(
  '[SharedAudit AircraftEvent] AircraftEventBusinessPerson Audit Loaded',
  props<{ aircraftEventBusinessPersonId: number; audits: PagedAircraftEventBusinessPersonAudit }>()
);

export const AircraftEventBusinessPersonAuditLoadError = createAction(
  '[SharedAUdit AircraftEvent] AircraftEventBusinessPerson Audit Load Error',
  props<{ err: any }>()
);

export const LoadScheduledEventAudit = createAction(
  '[SharedAudit AircraftEvent] Load ScheduledEvent Audit',
  props<{ scheduledEventId: number }>()
);

export const LoadNextPageScheduledEventAudit = createAction(
  '[SharedAudit AircraftEvent] Load Next Page ScheduledEvent Audit',
  props<{ scheduledEventId: number }>()
);

export const ScheduledEventAuditLoaded = createAction(
  '[SharedAudit AircraftEvent] ScheduledEvent Audit Loaded',
  props<{ scheduledEventId: number; audits: PagedScheduledEventAudit }>()
);

export const ScheduledEventAuditLoadError = createAction(
  '[SharedAudit AircraftEvent] ScheduledEvent Audit Load Error',
  props<{ err: any }>()
);

export const LoadAircraftEventTypes = createAction(
  '[SharedAudit AircraftEvent] Load AircraftEvent Types'
);

export const AircraftEventTypesLoaded = createAction(
  '[SharedAudit AircraftEvent] AircraftEvent Types Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const AircraftEventTypesLoadError = createAction(
  '[SharedAudit AircraftEvent] AircraftEvent Types Load Error',
  props<{ err: any }>()
);

export const LoadFlightBusinessPersonTypes = createAction(
  '[SharedAudit AircraftEvent] Load FlightBusinessPerson Types'
);

export const FlightBusinessPersonTypesLoaded = createAction(
  '[SharedAudit AircraftEvent] FlightBusinessPerson Types Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const FlightBusinessPersonTypesLoadError = createAction(
  '[SharedAudit AircraftEvent] FlightBusinessPerson Types Load Error',
  props<{ err: any }>()
);
